module.exports = __webpack_public_path__ + "img/img4zhTc.d69f55ab.png";